/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputIcon from 'DesignSystem/TysiaInput/TysiaInputIcon/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/Name",
  isInvalid,
  onChange
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let editProfessionalOtherExternalOfficeNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_professional',
path: 'other.external_office.name',
})
let editProfessionalOtherExternalOfficeNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'other.external_office.name',
validate: fromValidate.textInput,
required: true,
})
let editProfessionalOtherExternalOfficeNameChangeData = fromData.useDataChange({ viewPath,
context: 'edit_professional',
path: 'other.external_office.name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_professional.other.external_office.name"
 validate="/Data/validate.js textInput"
 required={true}
 invalid={!editProfessionalOtherExternalOfficeNameIsValidData}
 value={editProfessionalOtherExternalOfficeNameValueData}
 onChange={editProfessionalOtherExternalOfficeNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Office Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
<TysiaInputIcon
{...childProps}
  viewPath={`${viewPath}/TysiaInputIcon`}
/>
<button
  data-testid="Name.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Search/Content'))}
 {...isHoveredBind}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconSearch
  viewPath={`${viewPath}/TysiaIconSearch`}
/>
</button>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}